import {Price} from '../price';

export type UpsellBillingCycle = 'monthly' | 'yearly';

export function findBestPrice(
  token: UpsellBillingCycle,
  prices: Price[]
): Price | undefined {
  const sorted = sortPrices(prices);
  if (token === 'monthly') {
    return (
      sorted.find(p => p.interval === 'month' && p.interval_count === 1) ||
      sorted.find(p => p.interval === 'month') ||
      sorted[0]
    );
  }
  // yearly
  return (
    sorted.find(p => p.interval === 'year' && p.interval_count === 1) ||
    sorted.find(p => p.interval === 'year') ||
    sorted.find(p => p.interval === 'month' && p.interval_count >= 12) ||
    sorted[0]
  );
}

function sortPrices(prices: Price[]) {
  // ensure deterministic order: year(1), month(1), month(12), then others
  return [...prices].sort((a, b) => {
    const rank = (p: Price) => {
      if (p.interval === 'year' && p.interval_count === 1) return 0;
      if (p.interval === 'month' && p.interval_count === 1) return 1;
      if (p.interval === 'month' && p.interval_count === 12) return 2;
      return 3;
    };
    return rank(a) - rank(b);
  });
}
